import React from "react";
import HomeBanner from "./components/HomeBanner";
import './index.scss'
import HomeContainer from "./components/HomeContainer";

const PaiPointHome: React.FC = () => {
    return (
        <div className={'pai-point-home-container'}>
            <HomeBanner />
            <HomeContainer />
        </div>
    )
}

export default PaiPointHome